import React from "react";
import * as S from "./styled";

const CTA = () => (
  <S.CTASection>
    <S.CTAText>Gotowy na nowy poziom?</S.CTAText>
  </S.CTASection>
);

export default CTA;
